import { ReduxStore } from 'store/types';

export const getErrorDialogState = (state: ReduxStore) => state.errorDialog;
